import React from "react";
import { createRoot } from "react-dom/client";
import "./styles/index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";

import dayjs from "dayjs";
import buddhistEra from "dayjs/plugin/buddhistEra";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { APP_ENV } from "config";
// import customParseFormat from'dayjs/plugin/customParseFormat'
// import utc  from'dayjs/plugin/utc'
// dayjs.extend(customParseFormat)
// dayjs.extend(utc)
dayjs.extend(buddhistEra);
dayjs.extend(utc);
dayjs.extend(timezone);

import TimeAgo from "javascript-time-ago";
import th from "javascript-time-ago/locale/th.json";

TimeAgo.addLocale(th);

//<!-- Hotjar Tracking Code for https://m0.easyrice.ai -->
if (APP_ENV === "production") {
  (function (h: any, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: 2289045, hjsv: 6 };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
}
createRoot(document.getElementById("root")).render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
